import * as types from "../constants/actionTypes";


export const pricingInitialState = {
    quote: {},
    benefitDetails: [],
    appointments: [],
    appointmentsLoaded: false,
    selectedAppointment: {},
    selectedProxy: {},
    redirect: '',
    status:'',
    accessList: [],
    pdf: null,
    estimateDetailsTileMessageDetials: false
};

export default function pricingReducer(state = pricingInitialState, action) {
    switch (action.type) {
        case types.ESTIMATE_DETAILS_SCROLL_TO_BOTTOM_SUCCESS:
            return {...state };
        case types.ESTIMATE_DETAILS_TILE_MESSAGE_DETAILS_SUCCESS:
            return { ...state, estimateDetailsTileMessageDetials:action.isShown};
        case types.PRICING_USERSQUOTE_ESTIMATE_PDF_SUCCESS:
            return { ...state, pdf: action.pdf };
        case types.PRICING_USER_PROXY_SELECTED_INITIAL_STATE:
            return { ...state, redirect: '',benefitDetails:pricingInitialState.benefitDetails,quote:pricingInitialState.quote,selectedAppointment:pricingInitialState.selectedAppointment,accessList:pricingInitialState.accessList}
        case types.PRICING_USER_PROXY_SUCCESS:
            return { ...state, selectedProxy: action.prxy, redirect: '' };
        case types.PRICING_USERQUOTE_PROXYLIST_SUCCESS:
            return { ...state, accessList: action.accessList };
        case types.PRICING_USERSQUOTE_BENEFITDETAILS_SUCCESS:
            if (action.qt) {
                return { ...state, benefitDetails: action.ben, quote: action.qt, redirect: '' };
            } else {
                return { ...state,isDataLoaded: true, benefitDetails: action.ben, redirect: '' };
            }
        case types.PRICING_USERQUOTE_APPOINTMENTS_LOADING:
            return {
                ...state,
                appointments: [],
                appointmentsLoaded: false,
                redirect: ''
            }
        case types.PRICING_USERSQUOTE_APPOINTMENTS_SUCCESS:
            
            return {
                ...state,
                appointments: action.apts,
                appointmentsLoaded: true,
                redirect: ''
            };
        case types.PRICING_USERQUOTE_APPOINTMENTS_ERROR:
            console.error(`pricingReducer PRICING_USERQUOTE_APPOINTMENTS_ERROR `,state);
            return {...state,appointmentsLoaded: true}
        case types.PRICING_USERSQUOTE_QUOTE_CLEAR_SUCCESS:
            return pricingInitialState;
        default:
            return { ...state, redirect: ''};
    }
}

